/** Class names joined, the falsy ones left out. Without 'use client', so server components can use it too (ui.tsx re-exports it). */
export const cx = (...c: (string | false | null | undefined)[]) => c.filter(Boolean).join(' ');
